var __templateData = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
  var helper, functionType="function", helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;
  return "<div class=\"bottom-pane-bar closed\">\n  "
    + escapeExpression(((helper = (helper = helpers.paneTitle || (depth0 != null ? depth0.paneTitle : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"paneTitle","hash":{},"data":data}) : helper)))
    + "\n  <span class=\"arrow\"/>\n</div>\n<div class=\"pane-content\"></div>\n";
},"useData":true});
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}